import { FEED_FORMATS, NewDataFeed } from './types';

export const emptyFeedData: NewDataFeed = {
  alias: '',
  authToken: '',
  customHttpHeaders: [],
  format: FEED_FORMATS.JSON,
  name: '',
  rateLimitPerMin: null, // null signifies that no rate limit exists
  url: '',
};

export const DEFAULT_RATE_LIMIT_PER_SEC = 1000;

export const SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS = 500;
